
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-9481493c\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"@import \\\"~scss/variables\\\";\",\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BottomPaneSizer.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BottomPaneSizer.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9481493c\",\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BottomPaneSizer.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/appComponents/workbench/bottomPaneSizer/BottomPaneSizer.vue
// module id = 1894
// module chunks = 0